import { normalizeSort } from '../utils'
import NotificacionService from '../services/NotificacionService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['created_at'],
    sortDesc: [true]
  }
})

const getters = {
  NOTIFICACIONES: state => {
    return state.list
  },
  NOTIFICACIONES_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_NOTIFICACIONES: (state, payload) => {
    state.list = payload
  },
  SET_NOTIFICACIONES_PAG: (state, payload) => {
    state.pagination = payload
  },
  ENABLE_LOCATION: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_NOTIFICACIONES: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }
      let { data, status } = await NotificacionService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        // Aplicar el mismo filtro que en AppNotifications
        let filtered = data.data.filter(notification =>
          (notification.vehicle && notification.vehicle.status === 'pending') ||
          notification.movement
        )
        // Filtrar por usuario actual si se pasa user_id
        if (filter.user_id) {
          filtered = filtered.filter(n => n.user_id === filter.user_id)
        }
        // Ordenar por fecha (más reciente primero)
        filtered.sort((a, b) => (b.created_at || 0) - (a.created_at || 0))
        commit('SET_NOTIFICACIONES', filtered)
        return data._meta.totalCount
      }
    } catch (error) {
      if (error.response && error.response.data.data.status === 403) {
        console.error('No tiene permiso para ver esta información', error.response.data.data.status)
        window.app.$toast.error('No tiene permiso para ver esta información')
      } else {
        window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de notificaciones')
      }
    }
  },
  READ_NOTIFICATION: async ({ commit }, payload) => {
    try {
      let { status } = await NotificacionService.read(payload)
      if (status === 200) {
        commit('ENABLE_LOCATION', payload)
        return true
      }
    } catch (error) {
      console.error('Error al marcar notificación como leída:', error)
      if (error.response && error.response.data && error.response.data.data && error.response.data.data.status === 403) {
        window.app.$toast.error('No tiene permiso para realizar esta acción')
      } else {
        window.app.$toast.error('Ocurrió un problema al intentar marcar la notificación como leída')
      }
      throw error
    }
  },
  UNREAD_NOTIFICATION: async ({ commit }, payload) => {
    try {
      let { status } = await NotificacionService.unread(payload)
      if (status === 200) {
        commit('ENABLE_LOCATION', payload)
        return true
      }
    } catch (error) {
      console.error('Error al marcar notificación como no leída:', error)
      if (error.response && error.response.data && error.response.data.data && error.response.data.data.status === 403) {
        window.app.$toast.error('No tiene permiso para realizar esta acción')
      } else {
        window.app.$toast.error('Ocurrió un problema al intentar marcar la notificación como no leída')
      }
      throw error
    }
  },
  READ_ALL: async () => {
    try {
      let { status } = await NotificacionService.readAll()
      if (status === 200) {
        window.app.$toast.success('Notificación marcada como leída')
      }
    } catch (error) {
      if (error.response && error.response.data.data.status === 403) {
        console.error('No tiene permiso para ver esta información', error.response.data.data.status)
        window.app.$toast.error('No tiene permiso para ver esta información')
      } else {
        window.app.$toast.error('Ocurrió un problema al intentar leer la notificación')
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
